import { Button } from "../components/Button";
import { CheckboxField } from "../components/CheckboxField";
import { useFlow } from "../flow/FlowContext";
import { COMMUNITY_RULES } from "../flow/steps";
import { useT } from "../i18n";

export function CommunityRulesScreen() {
  const { answers, setRule, next, canContinue } = useFlow();
  const t = useT();

  return (
    <>
      <div className="screen-enter" style={{ flex: 1 }}>
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("rules.eyebrow")}</div>
          <h1 className="screen-head__title">{t("rules.title")}</h1>
          <p className="screen-head__text">{t("rules.text")}</p>
        </header>
        <div className="stack">
          {COMMUNITY_RULES.map((rule) => (
            <CheckboxField
              key={rule.key}
              id={`rule-${rule.key}`}
              checked={answers.rules[rule.key]}
              onChange={(v) => setRule(rule.key, v)}
              title={t(`rules.${rule.key}.title`)}
              description={t(`rules.${rule.key}.description`)}
            />
          ))}
        </div>
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("rules.agreeContinue")}
        </Button>
      </div>
    </>
  );
}
